/*
 * Copyright (C) 2019-present Arctic Ice Studio <development@arcticicestudio.com>
 * Copyright (C) 2019-present Sven Greb <development@svengreb.de>
 *
 * Project:    Arctic Ocean Fractal
 * Repository: https://github.com/arcticicestudio/arctic-ocean-fractal
 * License:    MIT
 */

import React from "react";
import posed from "react-pose";

import LightRing from "./styled/LightRing";
import {
  poseConfigAnglerfish,
  poseConfigAnglerfishEyeLens,
  poseConfigAnglerfishForeheadSkinFold
} from "../shared/poseConfig";
import nord from "../shared/nord";

const Group = posed.g(poseConfigAnglerfish);
const EyeLens = posed.path(poseConfigAnglerfishEyeLens);
const ForeheadSkinFold = posed.path(poseConfigAnglerfishForeheadSkinFold);

export default React.memo(props => (
  <Group {...props}>
    <path
      d="M510.92 373.25c3.66-.656 7.114-2.281 11.008-1.953 1.919.16 3.402.576 4.595 2.109 4.657 5.984 8.696 12.277 10.2 19.873-.471 1.441-1.643 2.094-2.936 2.611-9.708 3.871-19.372 7.854-29.035 11.836-1.344.553-2.747 1.129-4.2.217-.73-.623-1.335-1.361-1.653-2.256-2.376-6.645-1.99-12.734 1.152-19.252.353-.676.662-1.316.938-1.861 2.235-4.717 6.133-7.976 9.931-11.324z"
      fill={nord.nord8}
    />
    <ForeheadSkinFold
      d="M501.603 389.482c.52-3.16 1.694-5.855 4.088-7.92.478-.412 1.006-.855 1.615-.277.677.641.079 1.143-.329 1.561-1.869 1.902-3.133 4.1-3.431 6.789-.078.707-.002 1.693-.951 1.678-1.26-.02-.738-1.215-.992-1.831z"
      fill={nord.nord4}
    />
    <path
      d="M498.148 408.68c1.158.256 2.027-.439 2.972-.895 11.868-4.836 23.736-9.67 35.604-14.504.872 4.807.492 9.418-1.759 13.873-2.794 5.531-7.343 9.17-12.559 12.127a50.333 50.333 0 0 1-14.498 5.49c-7.725-1.516-14.265-4.842-18.313-11.977.216-.844.725-1.564 1.507-1.807 2.362-.729 4.532-2.057 7.046-2.307z"
      fill={nord.nord9}
    />
    <path
      d="M546.014 411.674c.879 3.168 1.414 6.262-1.782 8.582-1.751 2.832-4.686 2.451-7.237 2.25-2.605-.203-4.784.279-7.15 1.338-6.137 2.742-12.545 4.301-19.35 2.824-1.033-.225-4.141-1.389-4.749-2.377.341-2.148 4.389-1.188 5.846-1.676 2.515-.156 10.909-4.203 15.521-7.918 6.773-5.455 9.948-12.408 8.55-21.184-1.404-5.857-4.102-11.098-7.577-15.971-3.77-5.283-5.528-5.883-11.907-4.42-1.702.391-3.473 1.811-5.258.127 5.684-6.678 15.892-9.32 23.893-6.188 2.045 1.936 1.468 4.443 1.49 6.82.154 1.053.42 1.553 1.045 2.092.883 1.035 1.423.18 2.027-.361 1.085-.973 2.104-2.045 3.285-2.885 1.717-1.223 3.224-.875 3.996 1.154 1.169 3.068 2.986 4.859 6.583 4.443 2.146-.25 2.759 1.387 2.312 3.123-1.05 4.076.12 7.086 3.626 9.436 2.335 1.564 1.425 3.439-.169 4.984-3.013 2.924-6.784 4.467-10.775 5.463-3.384.844-5.293 5.227-3.461 8.186.435.709.828 1.439 1.241 2.158z"
      fill={nord.nord10}
    />
    <path
      d="M498.148 408.68c-2.463 2.174-5.826 2.484-8.553 4.115-1.286-5.168-.767-12.805 1.395-16.611.275 2.75-.059 5.08.566 7.307.612 2.178 1.288 4.289 3.035 6.363.58-3.18-.427-6.172 1.294-9.277.324 3.15.595 5.845 2.263 8.103zm6.053-14.225c-.041-1.908 2.105-4.217 4.016-4.061 2.245.182 3.65 1.57 3.948 3.789.255 1.9-1.938 4.139-3.873 4.191-2.124.06-4.046-1.782-4.091-3.919z"
      fill={nord.nord4}
    />
    <EyeLens
      d="M510.627 394.234c-.058 1.494-.773 2.412-2.228 2.527-1.088.088-2.628-.535-2.127-1.459.591-1.092-.728-3.514 1.952-3.344 1.48.097 2.225.899 2.403 2.276z"
      fill={nord.nord3}
    />
    <path
      d="M471.178 378.67c.369-.344.624-.615 1.003-.975 3.427-3.242 7.373-2.975 11.444-1.688 4.877 1.541 8.991 4.354 12.74 7.771 1.119 1.02 2.206 1.805 3.686 2.656.238-.467.701-1.395.938-1.861-1.076-.977-2.162-1.941-3.23-2.926-4.517-4.166-9.561-7.4-15.653-8.721-6.281-1.363-10.383.426-13.047 5.609.168-.006.333-.023.504-.023l1.615.158z"
      fill={nord.nord7}
    />
    <LightRing d="M457.267,390.807a12.295,12.295 0 1,0 24.59,0a12.295,12.295 0 1,0 -24.59,0" />
    <LightRing d="M469.597 381.592c1.566.553 3.383.611 4.788 1.436 3.575 2.102 5.124 7.023 3.696 11.023-1.39 3.895-5.493 6.561-9.546 6.205-3.99-.352-7.656-3.637-8.275-7.416-.771-4.719 1.092-8.365 5.244-10.246.943-.426 1.957-.557 2.904-.977l.117.223c.113 2.508-.917 3.313-2.085 4.961-2.289 2.346-2.806 4.236-1.539 6.342 1.231 2.041 3.003 3.076 5.478 2.719 2.416-.346 3.678-1.918 4.091-4.102.45-2.377-.565-4.289-2.657-5.488-1.703-1.629-2.251-2.139-2.387-4.387l.171-.293z" />
    <LightRing d="M469.597 381.592c-.167 1.734.259 2.777 2.256 3.338 2.707.762 4.496 3.969 3.993 6.666-.504 2.695-1.797 4.91-4.803 5.471-3.291.615-6.188-.785-7.537-3.576-1.296-2.684-.69-5.439 1.93-7.475 1.523-1.184 3.027-2.221 2.973-4.398l1.188-.026z" />
    <path
      d="M468.611 385.336c.358 1.316.878 2.135 2.146 2.779 1.642.836 2.81 2.359 1.328 4.359-1.141 1.541-2.707 2.156-4.349.996-1.747-1.234-1.71-3.064-.583-4.699.722-1.046 1.497-1.984 1.458-3.435z"
      fill={nord.nord13}
    />
  </Group>
));
